import React, { Component } from 'react';
import Table1_3 from "./1-3";
import Table1_1 from "./1-1KeyPerformanceIndicator";
import { Row, Button } from "antd";
import imgToPdf, { addPagePdf } from "imgtopdf";
import jsPDF from "jspdf";

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            print: false
        }
    }

    downloadSG = async () => {
        this.setState({ print: true }, () => {
            let arr = [{
                id: 'table1_1',
                multiple: 1.5
            }, {
                id: 'table1_3',
                multiple: 1.5
            }]

            imgToPdf('table1_3', 1.8).then(x => {
                let dataFrom = new FormData();
                dataFrom.append('img', x.img);
                dataFrom.append('sort', '1.3');
                dataFrom.append('height', x.canvas.height);
                dataFrom.append('width', x.canvas.width);
                dataFrom.append('year', '2018');
                dataFrom.append('month', '6');
                let headres = {
                    method: 'post',
                    credentials: 'include',
                    headers: {},
                    body: dataFrom
                }
                fetch('/addPdf', headres).then(x => x.json()).then(x => {
                    console.log(x);
                }).catch(err => {
                    console.error(err);
                })
                this.setState({
                    print: false
                });
            }).catch(err => {
                console.log(err)
            })

        });
    }

    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    1.0 KPI - Key Performance Indicator 关键绩效指数
                </Row>
                <Table1_1 {...this.props} />
                <Table1_3 {...this.props} />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/1-KPI/index.js